module.exports = __webpack_public_path__ + "img/day16.75160456.jpeg";